<!--<c-footer>-->
<div>
    <span>&copy; 2024 JDC Airports. - Cockpit <a [routerLink]="['/changelog']">v1.0.0</a></span>
</div>
<div class="ms-auto" *transloco="let t;">
    <button (click)="openSupportModal($event)" class="btn btn-info btn-sm btn-responsive">
        <i class="fas fa-bug"></i><span class="label">{{ t('support.issue.add.add_button') }}</span>
    </button>
</div>
<!--</c-footer>-->